import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  adminDetails:{},
  error: null,
  cancel: false,
  isSidebarVisible: true,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setAdminDetails: (state, action) => {
      state.adminDetails = action.payload;
      state.status = "succeeded";
    },
    setLoading: (state, action) => {
      state.status = "loading";
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setSidebarVisible: (state, action) => {
      state.isSidebarVisible = action.payload;
    },
  },
});

export const { setAdminDetails, setLoading, setError, setSidebarVisible } = adminSlice.actions;

export default adminSlice.reducer;
